import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ContactListProps, RenderConfig } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ContactList/RenderConfig"
import { t } from "@/languages/i18n"
import { DefaultImage } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"

export const ContactList: ComponentConfig<ContactListProps> = {
    label: "Tamda OC | Contact List",

    fields: {

        contacts: {
            label: "Contact List",
            type: "array",
            arrayFields: {
                image: {
                    label: "Contact Image",
                    type: "custom",
                    render: props => <MediaSelect {...props} mediaType="image" />,
                },
                title: {
                    label: "Contact Title",
                    type: "text",
                },
                address: {
                    label: "Contact Address",
                    type: "text",
                },
                email: {
                    label: "Contact Email",
                    type: "text",
                },
                phone: {
                    label: "Contact Phone",
                    type: "text",
                },
            },
        },
        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {

        contacts: [
            {
                image: DefaultImage,
                title: t("Administration OC Tamda and contact correspondence"),
                address: "Tamda Foods s.r.o, Havířská 352/17, Ústí nad Labem 400 10",
                email: "minhcau@tamda.eu",
                phone: "+420 773 313 868",
            },
        ],
        className: "",
    },
    ...RenderConfig,
}
